/** Matches server-side notion of Bizly staff (e.g. delegated-token creation blocked for admins). */
export function isBizlyEmployeeEmail(email: string | undefined | null): boolean {
    if (!email) return false;
    return email.toLowerCase().endsWith('@bizly.com');
}
